<template>
	<div class="px-6">
		<div class="flex items-center justify-between pt-4">
			<h2 class="mb-0 text-xl font-extrabold leading-none text-neutral-900">
				{{ $t('general.notifications') }}
			</h2>

			<button
				type="button"
				class="inline-flex items-center justify-center transition-colors rounded-lg size-7 text-neutral-900 hover:bg-neutral-100"
				:aria-label="$t('general.close')"
				@click="$emit('close')"
			>
				<IconTimes size="14" />
			</button>
		</div>

		<hr class="mt-3 mb-0" />

		<div class="pt-4 pb-2">
			<div class="flex items-center justify-between gap-3">
				<div class="inline-flex p-1 rounded-xl bg-neutral-100">
					<button
						type="button"
						class="min-w-[100px] px-4 py-2 text-sm transition-colors rounded-lg"
						:class="
							activeTab === 'unread'
								? 'bg-white text-neutral-900 shadow-sm'
								: 'text-neutral-700 hover:text-neutral-900'
						"
						data-test="notifications-tab-unread"
						@click="$emit('switch-tab', 'unread')"
					>
						{{ unreadTabLabel }}
					</button>

					<button
						type="button"
						class="min-w-[100px] px-4 py-2 text-sm transition-colors rounded-lg"
						:class="
							activeTab === 'read'
								? 'bg-white text-neutral-900 shadow-sm'
								: 'text-neutral-700 hover:text-neutral-900'
						"
						data-test="notifications-tab-read"
						@click="$emit('switch-tab', 'read')"
					>
						{{ $t('notification.read-tab') }}
					</button>
				</div>

				<div
					v-if="showHeaderActions"
					class="flex items-center"
					data-test="notifications-header-actions"
				>
					<Button
						v-if="showMarkAllAsRead"
						type="tertiary"
						size="sm"
						icon="check"
						@click="$emit('mark-all-as-read')"
					>
						{{ $t('notification.mark-all-as-read') }}
					</Button>
					<Button
						v-if="showDeleteAll"
						type="tertiary"
						size="sm"
						icon="trash-alt"
						@click="$emit('delete-all')"
					>
						{{ $t('notification.delete-all') }}
					</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { IconTimes } from '~/components/Icons'
import Button from '~/components/ui/common/Button'

export default {
	name: 'SlideoutHeader',
	components: {
		Button,
		IconTimes
	},
	props: {
		activeTab: {
			type: String,
			required: true
		},
		unreadTabLabel: {
			type: String,
			required: true
		},
		showDeleteAll: {
			type: Boolean,
			default: false
		},
		showHeaderActions: {
			type: Boolean,
			default: false
		},
		showMarkAllAsRead: {
			type: Boolean,
			default: false
		}
	}
}
</script>
